import {BreadcrumbJsonLd} from 'next-seo';
import {useRouter} from 'next/router';
import {getCurrentUrl} from '@app/modules/location';
import {useTranslation} from '@app/hooks/use-translation';

export const BreadcrumbStructuredData = () => {
	const {locale, asPath} = useRouter();
	const pathElements = asPath.split('/').filter((path) => path);
	const {t} = useTranslation();

	const itemListElements = [
		{
			name: t('Accueil', {
				ns: 'legacy',
			}),
			position: 1,
			item: getCurrentUrl({locale, pathname: '/'}),
		},
	];

	for (const [index, element] of pathElements.entries()) {
		itemListElements.push({
			name: element[0].toUpperCase() + element.slice(1, element.length), // Capitalize path element as name. We will need to change this to use a translation for each page name (not available right now).
			position: index + 2,
			item: getCurrentUrl({
				locale,
				pathname: `/${pathElements.slice(0, index + 1).join('/')}`,
			}),
		});
	}

	return <BreadcrumbJsonLd itemListElements={itemListElements} />;
};
